<template>
  <div style="" class="">
    <!-- <div class="p-4" style="background-color: #5e8dad; margin-top: 1vh;">
      <h1>Training Plan</h1>
      <button class="btn btn-primary" @click="showModal">+ Add Training Week</button>
    </div> -->

    <div class="pt-3 pl-3 pb-2" style="background-color: var(--bootstrapgrey); border-bottom-left-radius: 0px; border-top-left-radius: 0px;">
      <h3 class="section-title" style="text-transform: uppercase; font-weight: 400; color: #000;">Training Plan</h3>
      <!-- <button class="btn btn-primary" @click="showModal" style="float: right;">+ Add Training Week</button> -->
    </div>

    <button class="btn btn-primary mt-2 mb-2 ml-1" @click="showModal">+ Add Training Week</button>

    <div v-for="(week, index) in weeks" :key="week.id" class="ml-1">
      <!-- <div class="accordion mt-2" :style="{ show: openAccordion }">
        <div class="header" style="padding-left: 12px;" v-on:click="toggle">
          <slot name="header">{{ week.start_date }}<span v-if="week.week_type"> - {{ week.week_type }}</span></slot>
        </div>
        <transition name="accordion"
          v-on:before-enter="beforeEnter" v-on:enter="enter"
          v-on:before-leave="beforeLeave" v-on:leave="leave">
          <div class="body" v-show="show">
            <div class="body-inner">
              {{ week.trainingDays }}

              <button class="btn btn-danger" @click.prevent="deleteWeek(week.id)">Delete Week</button>
              <button class="btn btn-info" @click.prevent="showEditModal(week)">Edit Week</button>
            </div>
          </div>
        </transition>
      </div> -->

      <div class="week-header" :class="{ myrundash: !team || team == 'myrundash' || team == 'Demo', MDI: team == 'MDI', JKR: team == 'JKR' }" @click.prevent="showEditModal(week)" style="cursor: pointer;">
        Week#{{ weeks.length - index }} | {{ week.start_date }}<span v-if="week.week_type"> - {{ week.week_type }}</span>
        <!-- <div style="float: right" v-if="week.distance || week.actual_distance"><span v-if="week.actual_distance">{{ week.actual_distance | singleDecimal }} actual / </span><span v-if="wee.distance">{{ week.distance | singleDecimal }} planned</span> {{ distanceUnits }}</div> -->
        <div style="float: right" v-if="week.distance || week.actual_distance"><span v-if="week.actual_distance">{{ week.actual_distance | singleDecimal }} actual </span><span v-if="week.actual_distance && week.distance">/ </span><span v-if="week.distance">{{ week.distance | singleDecimal }} planned {{ distanceUnits }}</span><span v-if="week.striders"> | Striders: {{ week.striders }}</span></div>
      </div>

      <div v-if="week.trainingDays" class="row" style="">
        <!-- https://stackoverflow.com/questions/12851792/why-cant-i-decrease-the-line-height-of-this-text -->
        <div v-for="day in week.trainingDays" :key="day.id" @click="showEditDayModal(day)" class="training-day col-lg-1 col-sm-12" style="cursor: pointer; line-height: 1.15; overflow-wrap: break-word; margin-top: 1px;">
          <i v-if="day.filled" style="float: right; font-size: 13px;" class="material-icons">check_circle</i>

          <p style="font-weight: 700; margin-bottom: 0.5rem; cursor: pointer;">{{ day.day }}</p>

          <hr style="margin-top: 0.2rem; margin-bottom: 0.25rem;">
          <small style="color: grey;">{{ day.date }}
            <i v-if="day.activity == 'Run'" style="font-size: 14px; margin-left: 5px; color: var(--corelightcolor); float: right;" class="material-icons">directions_run</i>
            <i v-if="day.activity == 'Bike'" style="font-size: 14px; margin-left: 5px; color: var(--corelightcolor); float: right;" class="material-icons">directions_bike</i>
            <i v-if="day.activity == 'Swim'" style="font-size: 14px; margin-left: 5px; color: var(--corelightcolor); float: right;" class="material-icons">waves</i>
          </small>
          <h5 v-if="day.workout" style="margin-top: 2px;">{{ day.workout }}</h5>

          <!-- {{ day.actual_distance }} -->
          <div v-if="day.actual_distance != 0" style="margin-bottom: 4px;">
            <small class="day-info" v-if="!day.filled && day.distance && (day.workout != 'Intensity')">Distance: {{ day.distance | singleDecimal }}{{ distanceUnits }}</small>
            <small class="day-info" v-if="day.filled && day.actual_distance && (day.workout != 'Intensity')">{{ day.actual_distance | singleDecimal }}<span v-if="day.distance"> / {{ day.distance | singleDecimal }}</span> {{ distanceUnits }}</small>

            <small class="day-info" v-if="!day.filled && day.workout == 'Intensity'">{{day.intensity_reps}} x {{ day.distance * 1000 }}m</small>
            <small class="day-info" v-if="day.filled && day.workout == 'Intensity'">{{day.actual_reps}} x {{ day.actual_distance * 1000 }}m</small>

            <small class="day-info" v-if="!day.filled && (day.pace_minutes || day.pace_seconds)">Pace: {{ day.pace_minutes }}:{{ day.pace_seconds | twoDigits }}</small>
            <small class="day-info" v-if="day.filled && (day.actual_pace_minutes || day.actual_pace_seconds)">{{ day.actual_pace_minutes }}:{{ day.actual_pace_seconds | twoDigits }}<span v-if="day.pace_minutes || day.pace_seconds"> / {{ day.pace_minutes }}:{{ day.pace_seconds | twoDigits }}</span></small>

            <!-- Not much point showing rest interval once the day is filled -->
            <small class="day-info" v-if="!day.filled && (day.rest_minutes || day.rest_seconds)">Rest: {{ day.rest_minutes }}:{{ day.rest_seconds | twoDigits }}</small>

            <!-- We set the workout time to 0 for rest days, but there's not much benefit to actually showing that -->
            <div v-if="day.workout != 'Rest'">
              <small class="day-info" v-if="!day.filled && (day.time_hours || day.time_minutes || day.time_seconds)">Time: <span v-if="day.time_hours">{{ day.time_hours }}</span><span v-if="!day.time_hours">0</span>:{{ day.time_minutes | twoDigits }}:{{ day.time_seconds | twoDigits }}</small>
              <small class="day-info" v-if="day.filled && (day.time_hours || day.time_minutes || day.time_seconds || day.actual_time_hours || day.actual_time_minutes || day.actual_time_seconds)"><span v-if="day.actual_time_hours">{{ day.actual_time_hours }}</span><span v-if="!day.actual_time_hours">0</span>:{{ day.actual_time_minutes | twoDigits }}:{{ day.actual_time_seconds | twoDigits }} / <span v-if="day.time_hours">{{ day.time_hours }}</span><span v-if="!day.time_hours">0</span>:{{ day.time_minutes | twoDigits }}:{{ day.time_seconds | twoDigits }}</small>
            </div>

            <small class="day-info" v-if="!day.filled && day.target_hr && (day.workout != 'Fartlek')">Target HR: {{ day.target_hr }}</small>
            <small class="day-info" v-if="!day.filled && day.target_hr && (day.workout == 'Fartlek')">Net HR: {{ day.target_hr }}</small>
            <small class="day-info" v-if="day.filled && day.actual_hr">HR: {{ day.actual_hr }}<span v-if="day.target_hr"> / {{ day.target_hr }}</span></small>
            <small class="day-info" v-if="day.filled && day.striders">Striders: {{ day.striders }}</small>
          </div>
          <!-- <p>{{ day.actual_distance }}</p> -->
          <div v-if="day.actual_distance == 0">
            <small class="day-info mt-1" v-if="day.workout != 'X-Training'">Did not run.</small>
            <small class="day-info mt-1" v-if="day.workout == 'X-Training'">Did not X-train.</small>
          </div>

          <small v-if="day.filled && day.tracker_link"><a :href="day.tracker_link" target="_blank">Tracker Data</a></small>

          <div class="" v-if="day.filled" style="margin-top: 8px; margin-bottom: 10px;">
            <small class="other-stuff-check"><i v-if="!day.health_insurance" class="material-icons incomplete-icon">panorama_fish_eye</i><i v-if="day.health_insurance" class="material-icons complete-icon">check_circle</i> Health Insurance</small>
            <small class="other-stuff-check"><i v-if="!day.strength" class="material-icons incomplete-icon">panorama_fish_eye</i><i v-if="day.strength" class="material-icons complete-icon">check_circle</i> Strength Workout</small>
            <small class="other-stuff-check"><i v-if="!day.stretching" class="material-icons incomplete-icon">panorama_fish_eye</i><i v-if="day.stretching" class="material-icons complete-icon">check_circle</i> Stretching Routine</small>
            <small class="other-stuff-check"><i v-if="!day.eating" class="material-icons incomplete-icon">panorama_fish_eye</i><i v-if="day.eating" class="material-icons complete-icon">check_circle</i> Healthy Eating</small>
            <small class="other-stuff-check"><i v-if="!day.sleeping" class="material-icons incomplete-icon">panorama_fish_eye</i><i v-if="day.sleeping" class="material-icons complete-icon">check_circle</i> Good Sleep</small>
          </div>

          <div>
            <small style="" v-if="!day.filled">{{ day.comments }}</small>
            <small style="" v-if="day.filled">{{ day.notes }}</small>
          </div>

          <hr class="mobile-only">
        </div>
      </div>

      <!-- Because of this it renders without problems... -->
      {{ days.skdgkb }}

      <!-- <div class="mt-4" style="">
        <button class="btn btn-danger" @click.prevent="deleteWeek(week.id)">Delete Week</button>
        <button class="btn btn-info" @click.prevent="showEditModal(week)">Edit Week</button>
      </div> -->

      <hr class="web-only">
    </div>


    <!-- ---- WEEK MODAL ---- -->
    <!-- Need to raise the z-index above the sticky side bar (which is something like 1200) -->
    <modal name="week-modal" width="90%" height="500" class="" style="z-index: 9999;">
      <div class="p-4" style="">
        <h4 v-if="!editing" style="">Add Week</h4>
        <h4 v-if="editing" style="">Edit Week</h4>
        <form action="" class="">
          <div class="form-row">
            <div class="form-group col-md-6">
              <label for="">Start Date</label>
              <!-- https://www.npmjs.com/package/vuejs-datepicker -->
              <!-- https://codesandbox.io/s/mpklq49wp -->
              <datepicker class="form-control" :disabled-dates="disabledWeekStartDays" placeholder="Week Start Date (Monday)" v-model="startDate" style="padding: .37rem .75rem; line-height: 1;"></datepicker>
              <small v-if="$v.startDate.$invalid && updateClicked">The week start date is required.</small>
            </div>
            <div class="form-group col-md-6">
              <label for="raceType">Week Type</label>
              <select class="form-control" id="raceType" v-model="weekType">
                <option>Base Building</option>
                <option>Speed</option>
                <option>Taper</option>
              </select>
            </div>
          </div>
          <hr>
          <div v-if="editing" class="web-only">
            <button class="btn btn-info mr-1 mt-2" @click.prevent="closeModal">Cancel</button><button class="btn btn-danger mt-2" @click.prevent="deleteWeek(editWeek.id)" style="">Delete Week</button><button class="btn btn-primary mt-2" @click.prevent="updateWeek(editWeek.id)" style="float: right;">Update Week</button>
          </div>
          <div v-if="editing" class="mobile-only">
            <button class="btn btn-info mr-1 mt-2" @click.prevent="closeModal">Cancel</button><button class="btn btn-danger mt-2" @click.prevent="deleteWeek(editWeek.id)" style="">Delete Week</button><button class="btn btn-primary mt-2" @click.prevent="updateWeek(editWeek.id)" style="float: right;">Update</button>
          </div>
          <div v-if="!editing">
            <button class="btn btn-info mr-1" @click.prevent="closeModal">Cancel</button><button class="btn btn-primary" @click.prevent="saveWeek()" style="float: right;">Save Week</button>
          </div>
        </form>
      </div>
    </modal>

    <!-- ---- DAY MODAL ---- -->
    <!-- Need to raise the z-index above the sticky side bar (which is something like 1200) -->
    <div v-if="editDay">
      <modal name="day-modal" width="90%" height="auto" :scrollable='true' class="" style="z-index: 9999;">
        <div class="p-4" style="">
          <h4>Edit {{ editDay.day }} - {{ editDay.date }}</h4>
          <hr>
          <form action="" class="">
            <div class="row">
              <div class="col-lg-6"> <!-- Left side of the modal, the PLAN -->
                <h4>Plan</h4>
                <hr style="margin-bottom: 0.5rem;">
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label for="dayType">Workout Type</label>
                    <select class="form-control" id="dayType" v-model="dayType">
                      <option>OMP Flat</option>
                      <option>OMP Hilly</option>
                      <option>Intensity</option>
                      <option>Intensity (Tempo)</option>
                      <option>Intensity (Cruise-Tempo)</option>
                      <option>Race Pace</option>
                      <option>LSD</option>
                      <option>Progression Start</option>
                      <option>Progression Finish</option>
                      <option>Fartlek</option>
                      <option>X-Training</option>
                      <option>Easy Run</option>
                      <option>Rest</option>
                      <option>Race</option>
                    </select>
                  </div>
                  <div class="form-group col-md-6" v-if="dayType != 'Rest' && dayType != 'X-Training'">
                    <label for="dayType">Activity Type</label>
                    <select class="form-control" id="dayType" v-model="activity">
                      <option>Run</option>
                      <option>Bike</option>
                      <option>Swim</option>
                      <option value="">None of the above</option>
                    </select>
                  </div>
                <!-- ---- INSIDE DAY MODAL ---- -->
                </div>
                <div v-if="dayType != 'Rest' && dayType != ''">
                  <div class="form-row">
                    <div class="form-group col-md-3" :class="{ 'invalid': checkDecimal(distance) }">
                      <label v-if="dayType != 'Intensity'" for="distance">Distance ({{ distanceUnits }})</label>
                      <label v-if="dayType == 'Intensity'" for="distance">Rep Distance ({{ distanceUnits }})</label>
                      <!-- <input type="number" class="form-control" id="distance" placeholder="" v-model="distance"> -->
                      <input type="text" class="form-control" id="distance" placeholder="" v-model="distance">
                      <small v-if="checkDecimal(distance)">Must be a number!</small>
                    </div>
                    <div class="form-group col-md-2" v-if="dayType == 'Intensity'" :class="{ 'invalid': checkDecimal(intensityReps) }">
                      <label for="reps">Repeats</label>
                      <!-- <input type="number" class="form-control" id="reps" placeholder="" v-model="intensityReps"> -->
                      <input type="text" class="form-control" id="reps" placeholder="" v-model="intensityReps">
                      <small v-if="checkDecimal(intensityReps)">Must be a number!</small>
                    </div>

                    <div class="form-group col-md-4" v-if="dayType != 'X-Training'" :class="{ 'invalid': checkInteger(paceMinutes) || checkInteger(paceSeconds) }">
                      <label for="" v-if="dayType != 'Intensity'">Pace</label>
                      <label for="" v-if="dayType == 'Intensity'">Repeat Time</label>
                      <!-- <div class="form-row">
                        <div class="col-lg-6 col-md-6 input-group" style="padding-left: ; padding-right: 0;">
                          <input type="number" class="form-control" id="" placeholder="mins" v-model="paceMinutes" style="border-top-left-radius: ; border-bottom-left-radius: ;">
                          <div class="input-group-append">
                            <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-6" style="padding-left: 0; padding-right: 25px;">
                          <input type="number" class="form-control" id="" placeholder="secs" v-model="paceSeconds" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
                        </div>
                      </div> -->
                      <div class="input-group">
                        <input type="text" class="form-control" id="" placeholder="mins" v-model="paceMinutes" style="border-top-left-radius: ; border-bottom-left-radius: ;">
                        <div class="input-group-append">
                          <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
                        </div>
                        <input type="text" class="form-control" id="" placeholder="secs" v-model="paceSeconds" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
                      </div>
                      <small v-if="checkInteger(paceMinutes) || checkInteger(paceSeconds)">Must be an integer!</small>
                    </div>
                    <!-- ---- INSIDE DAY MODAL ---- -->
                    <!-- For cross training pace is irrelevant -->
                    <div class="form-group col-md-6" v-if="dayType == 'X-Training'" :class="{ 'invalid': checkInteger(timeHours) || checkInteger(timeMinutes) || checkInteger(timeSeconds) }">
                      <label for="">Time</label>
                      <div class="input-group">
                          <input type="text" class="form-control" id="" placeholder="hrs" v-model="timeHours" style="border-top-left-radius: ; border-bottom-left-radius: ;">
                          <div class="input-group-append">
                            <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
                          </div>
                          <input type="text" class="form-control" id="" placeholder="mins" v-model="timeMinutes" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
                          <div class="input-group-append">
                            <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
                          </div>
                          <input type="text" class="form-control" id="" placeholder="secs" v-model="timeSeconds" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
                      </div>
                      <small v-if="checkInteger(timeHours) || checkInteger(timeMinutes) || checkInteger(timeSeconds)">Must be an integer!</small>
                    </div>
                    <!-- ---- INSIDE DAY MODAL ---- -->
                    <!-- ------------------------------ -->
                    <div class="form-group col-md-3" :class="{ 'invalid': checkInteger(heartRate) }">
                      <label for="distance" v-if="dayType != 'Fartlek'">Avg Heart Rate</label>
                      <label for="distance" v-if="dayType == 'Fartlek'">Net Heart Rate</label>
                      <input type="text" class="form-control" id="distance" placeholder="" v-model="heartRate">
                      <small v-if="checkInteger(heartRate)">Must be an integer!</small>
                    </div>
                  </div>

                  <p v-if="totalWorkoutTime" style="display: block;"><label style="margin-top: 0;"><span style="display: none;">{{ totalWorkoutTime }}</span>Time:</label> {{ timeHours }}:{{ timeMinutes | twoDigits }}:{{ timeSeconds | twoDigits }}</p>

                  <!-- <div class="form-row" v-if="dayType == 'Intensity' || dayType == 'Marapace/Race' || dayType == 'Intensity (Tempo)' || dayType == 'Intensity (Cruise-Tempo)'"> -->
                  <div class="form-row" v-if="dayType != 'Rest' && dayType != 'X-Training'">
                    <div class="form-group col-md-3" :class="{ 'invalid': checkInteger(warmup) }">
                      <label for="distance">WU/CD ({{ distanceUnits }})</label>
                      <input type="text" class="form-control" id="distance" placeholder="" v-model="warmup">
                      <small v-if="checkInteger(warmup)">Must be an integer!</small>
                    </div>
                    <div class="form-group col-md-4" v-if="dayType == 'Intensity'" :class="{ 'invalid': checkInteger(restMinutes) || checkDecimal(restSeconds) }">
                      <label for="">Rest Interval</label>
                      <div class="input-group">
                        <input type="text" class="form-control" id="" placeholder="mins" v-model="restMinutes" style="border-top-left-radius: ; border-bottom-left-radius: ;">
                        <div class="input-group-append">
                          <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
                        </div>
                        <input type="text" class="form-control" id="" placeholder="secs" v-model="restSeconds" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
                      </div>
                      <small v-if="checkInteger(restMinutes) || checkDecimal(restSeconds)">Must be a number!</small>
                    </div>
                  </div>
                </div>

                <!-- ---- INSIDE DAY MODAL ---- -->
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <label for="comments">Comments</label>
                    <textarea class="form-control" id="notes" rows="3" v-model="comments" placeholder=""></textarea>
                    <!-- Need to keep the below so the computed property renders -->
                    <!-- <p style="display: none;">{{ workoutNotes }}</p> -->
                  </div>
                </div>
                <!-- {{ workoutNotes }} -->
              </div>
              <!-- ---- DAY MODAL ACTUAL RESULTS RIGHT SIDE ---- -->
              <div class="col-lg-6">
                <h4>Actual</h4>
                <hr style="margin-bottom: 0.5rem;">

                <!-- <div v-if="dayType != 'Rest' && dayType != ''"> -->
                <div>
                  <input type="checkbox" id="didntrun" v-model="didntRun">
                  <label v-if="dayType != 'X-Training'" for="didntrun" class="ml-1 mt-1">Didn't Run</label>
                  <label v-if="dayType == 'X-Training'" for="didntrun" class="ml-1 mt-1">Didn't X-Train</label>
                </div>

                <div v-if="!didntRun && dayType != 'Rest' && dayType != ''">
                  <div class="form-row">
                    <div class="form-group col-md-3" v-if="dayType != 'Intensity' && dayType != 'X-Training' && dayType != 'Rest'"> <!-- For Intensity we always enter pace/interval time, for x-training we always enter time, for rest we enter neither -->
                      <label>What do you know?</label>
                      <select class="form-control" v-model="whatsKnown">
                        <option>Time</option>
                        <option>Pace</option>
                      </select>
                    </div>
                  </div>

                  <div class="form-row" v-if="dayType != 'Rest' && dayType != ''">
                    <div class="form-group col-md-3" :class="{ 'invalid': checkDecimal(actualDistance) }">
                      <label v-if="dayType != 'Intensity'" for="distance">Distance ({{ distanceUnits }})</label>
                      <label v-if="dayType == 'Intensity'" for="distance">Rep Distance ({{ distanceUnits }})</label>
                      <input type="text" class="form-control" id="distance" v-model="actualDistance">
                      <small v-if="checkDecimal(actualDistance)">Must be a number!</small>
                    </div>
                    <div class="form-group col-md-2" v-if="dayType == 'Intensity'" :class="{ 'invalid': checkDecimal(actualReps) }">
                      <label for="actualreps">Repeats</label>
                      <input type="text" class="form-control" id="actualreps" v-model="actualReps">
                      <small v-if="checkDecimal(actualReps)">Must be a number!</small>
                    </div>

                    <div class="form-group col-md-4" v-if="(dayType != 'X-Training') && (dayType == 'Intensity' || whatsKnown == 'Pace')" :class="{ 'invalid': checkInteger(actualPaceMinutes) || checkInteger(actualPaceSeconds) }">
                      <label v-if="dayType != 'Intensity'">Pace</label>
                      <label v-if="dayType == 'Intensity'">Repeat Time</label>
                      <div class="input-group">
                        <input type="text" class="form-control" id="" placeholder="mins" v-model="actualPaceMinutes" style="border-top-left-radius: ; border-bottom-left-radius: ;">
                        <div class="input-group-append">
                          <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
                        </div>
                        <input type="text" class="form-control" id="" placeholder="secs" v-model="actualPaceSeconds" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
                      </div>
                      <small v-if="checkInteger(actualPaceMinutes) || checkInteger(actualPaceSeconds)">Must be an integer!</small>
                    </div>

                    <div class="form-group col-md-6" v-if="dayType == 'X-Training' || whatsKnown == 'Time'" :class="{ 'invalid': checkInteger(actualTimeHours) || checkInteger(actualTimeMinutes) || checkDecimal(actualTimeSeconds) }">
                      <label for="">Time</label>
                      <div class="input-group">
                        <input type="text" class="form-control" id="" placeholder="hrs" v-model="actualTimeHours" style="border-top-left-radius: ; border-bottom-left-radius: ;">
                        <div class="input-group-append">
                          <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
                        </div>
                        <input type="text" class="form-control" id="" placeholder="mins" v-model="actualTimeMinutes" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
                        <div class="input-group-append">
                          <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
                        </div>
                        <input type="text" class="form-control" id="" placeholder="secs" v-model="actualTimeSeconds" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
                      </div>
                      <small v-if="checkInteger(actualTimeHours) || checkInteger(actualTimeMinutes) || checkDecimal(actualTimeSeconds)">Must be an integer!</small>
                    </div>

                    <div class="form-group col-md-3" :class="{ 'invalid': checkInteger(actualHeartRate) }">
                      <label for="distance">Heart Rate</label>
                      <input type="text" class="form-control" id="distance" placeholder="" v-model="actualHeartRate">
                      <small v-if="checkInteger(actualHeartRate)">Must be an integer!</small>
                    </div>

                    <div class="col-sm-12">
                      <p v-if="actualWorkoutTime && whatsKnown == 'Pace'" style="display: block;"><label style="margin-top: 0;"><span style="display: none;">{{ actualWorkoutTime }}</span>Time:</label> {{ autoActualTimeHours }}:{{ autoActualTimeMinutes | twoDigits }}:{{ autoActualTimeSeconds | twoDigits }}</p>
                      <p v-if="actualWorkoutPace && whatsKnown == 'Time' && dayType != 'Intensity'" style="display: block;"><span style="display: none;">{{ actualWorkoutPace }}</span><label style="margin-top: 0;">Pace:</label> {{ autoActualPaceMinutes }}:{{ autoActualPaceSeconds | twoDigits }}</p>
                    </div>

                    <div class="form-group col-sm-12">
                      <label for="dataLink">Tracker/App Link</label>
                      <input type="text" class="form-control" id="dataLink" placeholder="Link to data from Garmin, Strava, etc." v-model="dataLink">
                    </div>
                  </div>

                  <!-- <div class="form-row" v-if="dayType == 'Intensity' || dayType == 'Intensity (Tempo)' || dayType == 'Intensity (Cruise-Tempo)' || dayType == 'Marapace/Race'"> -->
                  <div class="form-row">
                    <div class="form-group col-md-4" v-if="dayType != 'X-Training'" :class="{ 'invalid': checkDecimal(actualWarmup) }">
                      <label for="distance">WU/CD ({{ distanceUnits }})</label>
                      <input type="text" class="form-control" id="distance" placeholder="" v-model="actualWarmup">
                      <small v-if="checkDecimal(actualWarmup)">Must be a number!</small>
                    </div>
                    <div class="form-group col-md-4" :class="{ 'invalid': checkInteger(striders) }">
                      <label for="distance">Striders</label>
                      <input type="text" class="form-control" v-model="striders">
                      <small v-if="checkInteger(striders)">Must be an integer!</small>
                    </div>
                  </div>
                </div>

                <div class="form-row" style="margin-bottom: 6px;">
                  <div class="form-group col-md-2">
                    <label for="">Run Health Insurance?</label>
                    <div>
                      <input type="checkbox" id="healthInsurance" v-model="healthInsurance">
                      <label for="healthInsurance" class="ml-1 mt-1">Yes!</label>
                    </div>
                  </div>
                  <div class="form-group col-md-2">
                    <label for="">Strength Workout?</label>
                    <div>
                      <input type="checkbox" id="strength" v-model="strength">
                      <label for="strength" class="ml-1 mt-1">Yup</label>
                    </div>
                  </div>
                  <div class="form-group col-md-2">
                    <label for="">Stretching Routine?</label>
                    <div>
                      <input type="checkbox" id="stretching" v-model="stretching">
                      <label for="stretching" class="ml-1 mt-1">Mhmm</label>
                    </div>
                  </div>
                  <div class="form-group col-md-2">
                    <label for="">Healthy Eating?</label>
                    <div>
                      <input type="checkbox" id="eating" v-model="eating">
                      <label for="eating" class="ml-1 mt-1">Ya</label>
                    </div>
                  </div>
                  <div class="form-group col-md-2">
                    <label for="">Good Sleep?</label>
                    <div>
                      <input type="checkbox" id="sleeping" v-model="sleeping">
                      <label for="sleeping" class="ml-1 mt-1">Yessir</label>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <label for="notes">Notes</label>
                    <textarea class="form-control" id="actual_notes" rows="3" v-model="notes" placeholder="Weather conditions (heat/humidex, ice/snow), injuries, or anything else"></textarea>
                  </div>
                </div>
              </div>
            </div>
            <hr>
            <button class="btn btn-info mr-1 mb-3" @click.prevent="closeDayModal">Cancel</button>
            <button class="btn btn-danger mr-1 mb-3" @click.prevent="clearDay(editDay)">Erase Day's Data</button>
            <button class="btn btn-primary mb-3" @click.prevent="saveDay(editDay)" style="float: right;">Save Day</button>
          </form>
        </div>
      </modal>
    </div>

    <div>
      <!-- {{ weeks }} -->
      <!-- <hr> -->
      <!-- {{ days }} -->
    </div>

  </div>
</template>

<script>
  import axios from 'axios'
  import { required } from 'vuelidate/lib/validators'; // Validators pre built into vuelidate - lecture 373
  import Datepicker from 'vuejs-datepicker'; // https://www.npmjs.com/package/vuejs-datepicker

  // https://www.npmjs.com/package/vue-loading-overlay
  import Vue from 'vue';
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  // Init plugin
  Vue.use(Loading);

  export default {
    props: ['userID'],
    data () {
      return {
        user: {},
        distanceUnits: '',

        weeks: [],
        days: [],
        startDate: '',
        weekType: '',
        saveClicked: false,
        updateClicked: false,
        editing: false,
        editWeek: null, // Week being edited in th edit week modal
        disabledWeekStartDays: {days: [2, 3, 4, 5, 6, 0]},

        editDay: null,
        dayType: '',
        activity: 'Run',
        distance: null,
        warmup: null,
        paceMinutes: null,
        paceSeconds: null,
        heartRate: null,
        timeHours: null,
        timeMinutes: null,
        timeSeconds: null,
        comments: '',

        restMinutes: null,
        restSeconds: null,
        intensityReps: null,
        actualReps: null,

        whatsKnown: 'Time',
        actualDistance: null,
        actualWarmup: null,
        actualPaceMinutes: null,
        actualPaceSeconds: null,
        autoActualPaceMinutes: null,
        autoActualPaceSeconds: null,
        actualHeartRate: null,
        actualTimeHours: null,
        actualTimeMinutes: null,
        actualTimeSeconds: null,
        autoActualTimeHours: null,
        autoActualTimeMinutes: null,
        autoActualTimeSeconds: null,
        dataLink: '',
        striders: null,
        notes: '',

        healthInsurance: false,
        strength: false,
        stretching: false,
        eating: false,
        sleeping: false,

        didntRun: false,

        filled: false,

        show: false,
        gotDays: false,
        openAccordion: {
          'background-color': 'green',
        },

        team: '',
      }
    },
    validations: {
      startDate: {
        required,
      },
    },
    components: {
      Datepicker // https://www.npmjs.com/package/vuejs-datepicker
    },
    // https://stackoverflow.com/questions/45813347/difference-between-the-created-and-mounted-events-in-vue-js
    created () {
      this.getUserProfile();
      // this.getWeeks();

      this.team = this.$store.getters.team
    },
    computed: {
      totalWorkoutTime () {
        // If it's a X-Training workout, they need to be able to enter a time. If it's Intensity, total time is irrelevant.
        if (this.dayType == 'X-Training' || this.dayType == 'Intensity') {
          return null
        }
        // If the day type is rest, the planned workout time should be set to 0 (this will be important for calculating total workout times)
        // This is also important if a day is originally marked as some other type of workout and then gets changed to a rest day
        if (this.dayType == 'Rest') {
          this.timeHours = 0
          this.timeMinutes = 0
          this.timeSeconds = 0
          return null
        }
        // If they haven't yet entered a distance and at least a partial pace, no point returning a workout total time
        if (!this.distance) {
          return null
        }
        // if (!this.distance && ((!this.paceMinutes) || (!this.paceSeconds))) {
        //   return null
        // }
        if (!(this.paceMinutes || this.paceSeconds)) {
          return null
        }
        else {
          let paceInSecs = null
          if (this.paceMinutes) {
            paceInSecs += this.paceMinutes * 60
          }
          if (this.paceSeconds) {
            paceInSecs += this.paceSeconds * 1
          }
          paceInSecs = paceInSecs * this.distance // Multiply the pace by the distance to get the total running time

          // Convert the total running time in seconds to hours:minutes:seconds
          // https://stackoverflow.com/questions/6312993/javascript-seconds-to-time-string-with-format-hhmmss
          this.timeHours = Math.floor(paceInSecs / 3600)
          this.timeMinutes = Math.floor((paceInSecs - (this.timeHours * 3600)) / 60)
          this.timeSeconds = paceInSecs - (this.timeHours * 3600) - (this.timeMinutes * 60)
          return paceInSecs
        }
      },
      actualWorkoutTime () {
        if (this.dayType == 'X-Training') {
          return null
        }
        if (!this.actualDistance && !(this.actualPaceMinutes || this.actualPaceSeconds)) {
          return null
        }
        let paceInSecs = null
        if (this.actualPaceMinutes) {
          paceInSecs += this.actualPaceMinutes * 60
        }
        if (this.actualPaceSeconds) {
          paceInSecs += this.actualPaceSeconds * 1
        }

        if (this.dayType == 'Intensity' && this.actualReps) {
          paceInSecs = paceInSecs * (this.actualReps * 1) // If the workout is intensity it's not really pace, it's multiples of reps
        } else {
          paceInSecs = paceInSecs * this.actualDistance // If it is not intensity total time is just pace multiplied by distance
        }

        this.autoActualTimeHours = Math.floor(paceInSecs / 3600)
        this.autoActualTimeMinutes = Math.floor((paceInSecs - (this.autoActualTimeHours * 3600)) / 60)
        this.autoActualTimeSeconds = paceInSecs - (this.autoActualTimeHours * 3600) - (this.autoActualTimeMinutes * 60)
        return paceInSecs
      },
      // Not using this, see addWorkoutComments() method
      // workoutNotes () {
      //   if (this.dayType == 'Rest') {
      //     this.comments = 'Take the day completely off!'
      //   }
      //   else if (this.dayType == 'OMP Flat') {
      //     this.comments = '2nd half slightly faster than 1st half...average pace should be on target'
      //   }
      //   else if (this.dayType == 'OMP Plus') {
      //     this.comments = '1st 1/2: 15-20 sec/km slow, 1-2min rest, 2nd 1/2: 15-20 sec/km faster (or 25-30 sec/mi slower/faster)'
      //   }
      //   else if (this.dayType == 'OMP Hilly') {
      //     this.comments = '2nd half slightly faster than 1st half (APPRX. 1 HILL / 1mi or 2km)'
      //   }
      //   else if (this.dayType == 'X-Training') {
      //     this.comments = 'Easy intensity alternate activity...no running!'
      //   }
      //   else if (this.dayType == 'Intensity') {
      //     this.comments = ' x @ exactly 5% faster than   pace'
      //   }
      //   else if (this.dayType == 'Intensity (Tempo)') {
      //     this.comments = 'Remember to \'sandwich\' tempo work between the warmup & cooldown'
      //   }
      //   else if (this.dayType == 'Intensity (Cruise-Tempo)') {
      //     this.comments = 'Run @ tempo pace & take 1 min. rest every 10 min. (don\'t count rest in w/o)'
      //   }
      //   else if (this.dayType == 'Progression Start') {
      //     this.comments = 'Easy OMP set up for tomorrow\'s progression run finish'
      //   }
      //   else if (this.dayType == 'Progression Finish') {
      //     this.comments = '1st 3rd: >20s/K-30s/M Slow, 2nd 3rd: Near Trgt LSD pace, 3rd 3rd: >20s/K-30s/M FAST, LAST 3M/5K @ RP or faster'
      //   }
      //   else if (this.dayType == 'Marapace/Race') {
      //     this.comments = ''
      //   }
      //   else if (this.dayType == 'LSD') {
      //     this.comments = 'Relax and enjoy it! Do 3-4 striders at the finish though'
      //   }
      //   else if (this.dayType == 'Fartlek') {
      //     this.comments = '1min. HARD (10K pace) & 2min EASY (L.S.D.), Repeat. Concentrate on form!'
      //   }
      //   else if (this.dayType == 'Race') {
      //     this.comments = 'Show time!'
      //   }
      //   else {
      //     this.comments = ''
      //   }
      //   return this.comments
      // },
      actualWorkoutPace() {
        if (!this.actualDistance && !(this.actualTimeHours || this.actualTimeMinutes || this.actualTimeSeconds)) {
          return null
        }
        let actualTimeInSecs = this.convertTimeToSeconds(this.actualTimeHours, this.actualTimeMinutes, this.actualTimeSeconds)
        this.autoActualPaceMinutes = this.convertSecondsToTime(actualTimeInSecs / this.actualDistance).minutes
        this.autoActualPaceSeconds = this.convertSecondsToTime(actualTimeInSecs / this.actualDistance).seconds
        return actualTimeInSecs
      },
      dayFilled () {
        if (this.notes) {
          return true
        }
        else {
          return false
        }
      }
    },
    methods: {
      toggle: function() {
        this.show = !this.show;
      },
      beforeEnter: function(el) {
        el.style.height = '0';
      },
      enter: function(el) {
        el.style.height = el.scrollHeight + 'px';
      },
      beforeLeave: function(el) {
        el.style.height = el.scrollHeight + 'px';
      },
      leave: function(el) {
        el.style.height = '0';
      },
      /* ---- End of Accordion methods --- */
      getUserProfile () {
        // userID is a prop, the idea being that it can be passed in via the coach's dashboard or elsewhere to view anyone's training plan
        // If it's not passed in, then we just get the training plan of whoever is logged in
        if (!this.userID) {
          this.$store.dispatch('getUser').then(() => { // Lecture 360
            this.user = this.$store.getters.user
            this.distanceUnits = this.user.preferred_distance_units
            console.log(this.$store.getters.user)
            this.getWeeks();
            // this.getDays();
          })
        }
        else {
          axios.get('/api/users/?id='.concat(this.userID))
            .then(res => {
              this.user = res.data[0]
              this.distanceUnits = this.user.preferred_distance_units
              this.getWeeks();
            })
            .catch(error => console.log(error))
        }
      },
      getWeeks () {
        console.log('Getting training weeks');

        // https://www.npmjs.com/package/vue-loading-overlay
        let loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          // container: this.$refs.formContainer,
          // canCancel: true,
          canCancel: false,
          // onCancel: this.onCancel,
        });
        // simulate AJAX
        setTimeout(() => {
          loader.hide()
        },2500)

        axios.get('/api/weeks/?user='.concat(this.user.id.toString()))
          .then(res => {
            console.log(res)
            this.weeks = res.data

            // for (var week in this.weeks) {
            //   this.weeks[week].trainingDays = []
            // }

            this.getDays()
            // for (var week in this.weeks) {
            //   this.getTrainingDays()
            // }
          })
          .catch(error => console.log(error))
      },
      getDays () {
        console.log('Getting training days')

        for (var week in this.weeks) {
          // console.log(this.weeks[week].id)

          axios.get('/api/days/?user='.concat(this.user.id.toString()).concat('&week=').concat(this.weeks[week].id).toString())
            .then(res => {

              // this.days.weekID = res.data
              // this.days = res.data
              // this.weeks[week].trainingDays = res.data[0]
              // this.weeks[week].pigloo2 = 'howdy'

              // Because the axios get run asynchronously, the for loop elements can't be referenced, the for loop will have already completed by the time this code runs
              // First we find the week corresponding to the days we just got (presumably every week will have days)
              // https://stackoverflow.com/questions/13964155/get-javascript-object-from-array-of-objects-by-value-of-property
              var correspondingWeek = this.weeks.find(obj => {
                return obj.id === res.data[0].week
              })
              // console.log(correspondingWeek.id)
              let weekID = correspondingWeek.id
              // console.log(weekID)

              // console.log('Training days for week: '.concat(correspondingWeek.start_date).toString())
              // console.log(res)

              correspondingWeek.trainingDays = res.data
              /////// Somehow because of this the days render without an issue...
              // Trying to add a timeout didn't produce an equivalent effect: https://stackoverflow.com/questions/17883692/how-to-set-time-delay-in-javascript
              this.days.push({
                // https://stackoverflow.com/questions/19837916/creating-object-with-dynamic-keys
                // [weekID]: res.data
                // [weekID]: 'pig'
                // 'test': 'Test'
              })
              ///////////
              this.gotDays = true
            })
            .catch(error => console.log(error))
        }
        // console.log(this.days)
        console.log('Done for loop')
        // console.log(this.weeks)

        // axios.get('/api/days/?user='.concat(this.user.id.toString()))
        //   .then(res => {
        //     console.log(res)
        //     this.days = res.data
        //   })
        //   .catch(error => console.log(error))
      },
      saveWeek () {
        this.saveClicked = true

        // console.log(this.quoteContent)
        // console.log(this.author)

        let options = { year: 'numeric', month: '2-digit', day: '2-digit' };

        axios.post('/api/weeks/',
          {
            user: this.user.id, // https://stackoverflow.com/questions/39001486/posting-a-foreign-key-relationship-in-django-rest-framework
            start_date: this.startDate.toLocaleDateString("en-US", options),
            week_type: this.weekType,
          }
        )
          .then(res => {
            console.log(res)
            // this.getWeeks() // Refresh the list of weeks after adding a new one (NOTE: We'll do it after we create the days)
            // this.clearWeekForm()
            this.closeModal() // Close the week modal
            this.saveClicked = false

            // console.log(this.startDate)
            this.createDays(res.data.id, res.data.start_date)
            this.clearWeekForm()
            this.getWeeks()
          })
          .catch(error => console.log(error))
      },
      createDays (weekID, weekStartDate) {
        //
        // Run whenever someone creates a new week to create the seven corresponding days
        //
        console.log('Creating days for week: '.concat(weekID.toString()))

        // When pulling the date from the database, it's in the YYYY-MM-DD format
        // So when we try to run toLocaleDateString on it, it doesn't work because it expects a javascript date object
        // So we convert the date to a javascript date object to ensure we can convert it back without issues later
        // startDate = new Date(startDate)
        weekStartDate = this.addCurrentTimeToDate(weekStartDate)
        console.log(weekStartDate)
        let options = { year: 'numeric', month: '2-digit', day: '2-digit' };

        const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']

        // Date.prototype.addDays = function(numdays) {
        //   var date = new Date(this.valueOf());
        //   date.setDate(date.getDate() + numdays);
        //   return date;
        // }

        for (var day in days) {
          console.log(days[day])
          console.log(Number(day))

          let dayDate = this.addDays(weekStartDate, Number(day)) // https://gomakethings.com/converting-strings-to-numbers-with-vanilla-javascript/

          axios.post('/api/days/',
            {
              user: this.user.id, // https://stackoverflow.com/questions/39001486/posting-a-foreign-key-relationship-in-django-rest-framework
              week: weekID,
              date: dayDate.toLocaleDateString("en-US", options),
              day: days[day],
            }
          )
            .then(res => {
              console.log(res)
              // this.getWeeks() // Refresh the list of weeks after adding a new one (NOTE: If called here it gets called 7 times)
              // this.getDays() // (NOTE: We do this in getWeeks)
              // this.clearWeekForm()
              // this.closeModal() // Close the quote modal
              // this.saveClicked = false

              // this.createDays(res.data.id)
            })
            .catch(error => console.log(error))
        }
      },
      saveDay(day) {
        console.log('Updating day: '.concat(day.id.toString()).concat(' - ').concat(day.date))

        // console.log(this.filled)
        if ((this.notes != '') || this.actualDistance || this.actualWarmup || this.actualTimeHours || this.actualTimeMinutes ||
            this.actualTimeSeconds || this.actualPaceMinutes || this.actualPaceSeconds || this.actualHeartRate || this.actualReps || this.striders ||
            this.dataLink || this.healthInsurance || this.strength || this.stretching || this.eating) {
          this.filled = true
          console.log('Day is filled')
        }
        else {
          this.filled = false // If something was filled initially and then it was cleared, the filled flag would have already been true, so it needs to be explicilty set back to false
        }
        // console.log(this.filled)

        // console.log(this.didntRun)
        if (this.didntRun) {
          this.actualDistance = 0
          // this.actual_warmup = 0
          // this.actual_time_hours = 0
          // this.actual_time_minutes = 0
          // this.actual_time_seconds = 0
          // this.actual_pace_minutes = 0
          // this.actual_pace_seconds = 0
          // this.actual_reps = 0
        }

        // If the user has not added custom comments, try to insert the generic
        if (!this.comments) {
          this.addWorkoutComments()
        }

        // If the time or pace wasn't explicitly entered, we need to save the auto calculated value
        if (!this.actualPaceMinutes) { this.actualPaceMinutes = this.autoActualPaceMinutes }
        if (!this.actualPaceSeconds) { this.actualPaceSeconds = this.autoActualPaceSeconds }
        if (!this.actualTimeHours) { this.actualTimeHours = this.autoActualTimeHours }
        if (!this.actualTimeMinutes) { this.actualTimeMinutes = this.autoActualTimeMinutes }
        if (!this.actualTimeSeconds) { this.actualTimeSeconds = this.autoActualTimeSeconds }

        // Need to limit the number of decimal placed to correspond with the django database requirements
        if (this.timeSeconds != null) {
          this.timeSeconds = Math.round(this.timeSeconds * 100) / 100 // https://stackoverflow.com/questions/11832914/round-to-at-most-2-decimal-places-only-if-necessary
        }
        if (this.actualTimeSeconds != null) {
          // When the total time is calculated, it outputs some weird floating point number
          // console.log('Converting seconds')
          // console.log(this.actualTimeSeconds * 100)
          // console.log(Math.round(this.actualTimeSeconds * 100))
          // console.log(Math.round(this.actualTimeSeconds * 100) / 100)
          this.actualTimeSeconds = Math.round(this.actualTimeSeconds * 100) / 100 // https://stackoverflow.com/questions/11832914/round-to-at-most-2-decimal-places-only-if-necessary
        }
        // console.log(this.actualTimeSeconds)
        // Actual pace seconds is just an integer field, no decimals
        if (this.actualPaceSeconds != null) {
          // this.actualPaceSeconds = Math.round(this.actualPaceSeconds * 100) / 100 // https://stackoverflow.com/questions/11832914/round-to-at-most-2-decimal-places-only-if-necessary
          this.actualPaceSeconds = Math.round(this.actualPaceSeconds)
        }

        console.log(this.dayType)
        console.log(this.distance)
        console.log(this.warmup)
        console.log(this.paceMinutes)
        console.log(this.paceSeconds)
        console.log(this.heartRate)
        console.log(this.timeHours)
        console.log(this.timeMinutes)
        console.log(this.timeSeconds)
        console.log(this.comments)
        console.log(this.restMinutes)
        console.log(this.restSeconds)
        console.log('-')
        console.log(this.notes)
        console.log(this.actualDistance)
        console.log(this.actualWarmup)
        console.log(this.actualTimeHours)
        console.log(this.actualTimeMinutes)
        console.log(this.actualTimeSeconds)
        console.log(this.actualPaceMinutes)
        console.log(this.actualPaceSeconds)
        console.log(this.actualHeartRate)
        console.log(this.actualReps)
        console.log(this.striders)
        console.log(this.dataLink)
        console.log(this.healthInsurance)
        console.log(this.strength)
        console.log(this.stretching)
        console.log(this.eating)
        console.log(this.sleeping)

        axios.patch('/api/days/'.concat(day.id.toString()).concat('/'),
          {
            workout: this.dayType,
            activity: this.activity,
            distance: this.distance,
            warmup: this.warmup,
            pace_minutes: this.paceMinutes,
            pace_seconds: this.paceSeconds,
            target_hr: this.heartRate,
            time_hours: this.timeHours,
            time_minutes: this.timeMinutes,
            time_seconds: this.timeSeconds,
            comments: this.comments,

            actual_distance: this.actualDistance,
            actual_warmup: this.actualWarmup,
            actual_time_hours: this.actualTimeHours,
            actual_time_minutes: this.actualTimeMinutes,
            actual_time_seconds: this.actualTimeSeconds,
            // When the total time is calculated, it outputs some weird floating point number
            // actual_time_seconds: Math.round(this.actualTimeSeconds * 100) / 100, // https://stackoverflow.com/questions/11832914/round-to-at-most-2-decimal-places-only-if-necessary
            actual_pace_minutes: this.actualPaceMinutes,
            actual_pace_seconds: this.actualPaceSeconds,
            actual_hr: this.actualHeartRate,
            notes: this.notes,

            rest_minutes: this.restMinutes,
            rest_seconds: this.restSeconds,
            intensity_reps: this.intensityReps,
            actual_reps: this.actualReps,

            health_insurance: this.healthInsurance,
            strength: this.strength,
            stretching: this.stretching,
            eating: this.eating,
            sleeping: this.sleeping,

            filled: this.filled,

            tracker_link: this.dataLink,

            striders: this.striders,
          }
        )
            .then(res => {
              console.log(res)
              this.getWeeks()
              this.clearDayForm()
              this.closeDayModal()

              axios.get('/api/days/?week='.concat(day.week.toString()))
                .then(res => {
                  console.log('All days for this week:')
                  console.log(res)
                  this.calculateWeeklyDistance(res.data, day.week)
                })
                .catch(error => { console.log(error)})
            })
            .catch(error => {
              console.log(error)
            })
      },
      clearDay(day) {
        //
        // Clear all the data associated with a day
        //
        axios.patch('/api/days/'.concat(day.id.toString()).concat('/'),
          {
            workout: '',
            activity: 'Run',
            distance: null,
            warmup: null,
            pace_minutes: null,
            pace_seconds: null,
            target_hr: null,
            time_hours: null,
            time_minutes: null,
            time_seconds: null,
            comments: '',

            actual_distance: null,
            actual_warmup: null,
            actual_time_hours: null,
            actual_time_minutes: null,
            actual_time_seconds: null,
            // When the total time is calculated, it outputs some weird floating point number
            // actual_time_seconds: Math.round(this.actualTimeSeconds * 100) / 100, // https://stackoverflow.com/questions/11832914/round-to-at-most-2-decimal-places-only-if-necessary
            actual_pace_minutes: null,
            actual_pace_seconds: null,
            actual_hr: null,
            notes: '',

            rest_minutes: null,
            rest_seconds: null,
            intensity_reps: null,
            actual_reps: null,

            health_insurance: false,
            strength: false,
            stretching: false,
            eating: false,
            sleeping: false,

            filled: false,

            tracker_link: '',

            striders: null,
          }
        )
          .then(res => {
            console.log(res)
            this.getWeeks()
            this.clearDayForm()
            this.closeDayModal()

            axios.get('/api/days/?week='.concat(day.week.toString()))
              .then(res => {
                console.log('All days for this week:')
                console.log(res)
                this.calculateWeeklyDistance(res.data, day.week)
              })
              .catch(error => { console.log(error)})
          })
          .catch(error => {
            console.log(error)
          })
      },
      calculateWeeklyDistance(days, weekID) {
        console.log(weekID)
        let plannedDistance = 0
        let actualDistance = 0
        let totalStriders = 0
        for (var day in days) {
          if (days[day].workout != 'X-Training') { // Cross training is considered "Alternate Distance"
            console.log(days[day].distance)
            console.log(days[day].actual_distance)
            if (days[day].intensity_reps) {
              plannedDistance = plannedDistance + days[day].intensity_reps * (days[day].distance * 1) + (days[day].warmup * 1)
            }
            else {
              plannedDistance = plannedDistance + (days[day].distance * 1) + (days[day].warmup * 1)
            }

            if (days[day].actual_reps) {
              actualDistance = actualDistance + days[day].actual_reps * (days[day].actual_distance * 1) + (days[day].actual_warmup * 1)
            }
            else {
              actualDistance = actualDistance + (days[day].actual_distance * 1) + (days[day].actual_warmup * 1)
            }
          }
          // Add up all the striders for the week
          totalStriders += days[day].striders
        }
        console.log(plannedDistance)
        console.log(actualDistance)
        axios.patch('/api/weeks/'.concat(weekID.toString()).concat('/'),
          {
            // https://www.geeksforgeeks.org/round-off-a-number-upto-2-decimal-place-using-javascript/
            distance: plannedDistance.toFixed(2),
            actual_distance: actualDistance.toFixed(2),
            striders: totalStriders
          }
        )
          .then(res => {
            console.log(res)
            this.getWeeks() // Refresh the list of weeks after editing one
          })
          .catch(error => {
            console.log(error)
          })
      },
      updateWeek (weekID) {
        console.log('Updating week: '.concat(weekID.toString()))
        this.updateClicked = true

        // When pulling the date from the database, it's in the YYYY-MM-DD format
        // So when we try to run toLocaleDateString on it, it doesn't work because it expects a javascript date object
        // So we convert the date to a javascript date object to ensure we can convert it back without issues later
        this.startDate = new Date(this.startDate)
        let options = { year: 'numeric', month: '2-digit', day: '2-digit' }; // Format the date in a way Django accepts

        axios.patch('/api/weeks/'.concat(weekID.toString()).concat('/'),
          {
            start_date: this.startDate.toLocaleDateString("en-US", options),
            week_type: this.weekType,
          }
        )
          .then(res => {
            console.log(res)
            this.getWeeks() // Refresh the list of weeks after editing one
            this.clearWeekForm()
            this.closeModal() // Close the quote modal
            this.updateClicked = false
          })
          .catch(error => {
            console.log(error)
          })
      },
      showModal() {
        // NEED TO ADD SOMETHING TO CLEAR THE MODAL BEFORE SHOWING IT FOR ADDING A NEW WEEK
        this.startDate = ''
        this.weekType = ''

        this.editing = false
        this.$modal.show('week-modal'); // npmjs.com/package/vue-js-modal
      },
      showEditModal(week) {
        this.editing = true

        this.editWeek = week
        // this.startDate = week.start_date
        // https://github.com/charliekassel/vuejs-datepicker/issues/23
        // https://github.com/charliekassel/vuejs-datepicker/issues/118
        this.startDate = new Date(week.start_date.concat('T00:00:00')) // The date was showing as one day previous, because it was being set as 00:00:00 UTC, and then subtracting 5 hours for ET, which made it one day early
        console.log(week.start_date)
        console.log(this.startDate)
        this.weekType = week.week_type
        this.$modal.show('week-modal'); // npmjs.com/package/vue-js-modal
      },
      showEditDayModal(day) {
        // this.editing = true
        this.clearDayForm()

        this.editDay = day
        this.dayType = day.workout
        this.activity = day.activity
        this.distance = day.distance
        this.warmup = day.warmup
        this.paceMinutes = day.pace_minutes
        this.paceSeconds = day.pace_seconds
        this.heartRate = day.target_hr
        this.timeHours = day.time_hours
        this.timeMinutes = day.time_minutes
        this.timeSeconds = day.time_seconds

        this.actualDistance = day.actual_distance
        this.actualWarmup = day.actual_warmup
        this.actualPaceMinutes = day.actual_pace_minutes
        this.actualPaceSeconds = day.actual_pace_seconds
        this.actualHeartRate = day.actual_hr
        this.actualTimeHours = day.actual_time_hours
        this.actualTimeMinutes = day.actual_time_minutes
        this.actualTimeSeconds = day.actual_time_seconds
        this.dataLink = day.tracker_link

        this.restMinutes = day.rest_minutes
        this.restSeconds = day.rest_seconds
        this.intensityReps = day.intensity_reps
        this.actualReps = day.actual_reps

        this.striders = day.striders

        this.healthInsurance = day.health_insurance
        this.strength = day.strength
        this.stretching = day.stretching
        this.eating = day.eating
        this.sleeping = day.sleeping

        this.comments = day.comments
        this.notes = day.notes

        this.$modal.show('day-modal'); // npmjs.com/package/vue-js-modal
      },
      closeModal() {
        this.$modal.hide('week-modal'); // npmjs.com/package/vue-js-modal
        this.clearWeekForm()
      },
      closeDayModal() {
        this.$modal.hide('day-modal'); // npmjs.com/package/vue-js-modal
        // this.clearWeekForm()
      },
      deleteWeek(weekID) {
        console.log(weekID)
        axios.delete('/api/weeks/'.concat(weekID.toString()).concat('/'))
          .then(res => {
            console.log(res)
            console.log(res.data.id)
            this.getWeeks() // Refresh the list of quotes after deleting one
            // this.getDays()
            this.$modal.hide('week-modal'); // npmjs.com/package/vue-js-modal

            this.toggle() // Close the accordions so someone doesn't keep hitting delete
          })
          .catch(error => console.log(error))
      },
      clearWeekForm() {
        this.startDate = ''
        this.weekType = ''

        this.editing = false
      },
      clearDayForm() {
        this.editDay = null
        this.dayType = ''
        this.activity = 'Run'
        this.distance = null
        this.warmup = null
        this.paceMinutes = null
        this.paceSeconds = null
        this.heartRate = null
        this.timeHours = null
        this.timeMinutes = null
        this.timeSeconds = null

        this.actualDistance = null
        this.actualWarmup = null
        this.actualPaceMinutes = null
        this.actualPaceSeconds = null
        this.actualHeartRate = null
        this.actualTimeHours = null
        this.actualTimeMinutes = null
        this.actualTimeSeconds = null
        this.dataLink = ''

        this.autoActualPaceMinutes = null
        this.autoActualPaceSeconds = null
        this.autoActualTimeHours = null
        this.autoActualTimeMinutes = null
        this.autoActualTimeSeconds = null

        this.restMinutes = null
        this.restSeconds = null
        this.intensityReps = null
        this.actualReps = null

        this.healthInsurance = false
        this.strength = false
        this.stretching = false
        this.eating = false
        this.sleeping = false

        this.comments = ''
        this.notes = ''
        this.dataLink = ''
        this.filled = false
        this.striders = null

        this.didntRun = false
      },
      addCurrentTimeToDate(date) {
        let today = new Date()
        let hourNow = today.getHours()
        // https://stackoverflow.com/questions/18889548/javascript-change-gethours-to-2-digit
        // Need to make sure each of these values is 2 digits, otherwise it breaks the human date generation below
        hourNow = ("0" + hourNow).slice(-2);
        let minuteNow = today.getMinutes()
        minuteNow = ("0" + minuteNow).slice(-2);
        let secondNow = today.getMinutes()
        secondNow = ("0" + secondNow).slice(-2);

        return new Date(date.concat('T').concat(hourNow).concat(':').concat(minuteNow).concat(':').concat(secondNow))
      },
      addDays(date, days) {
        // Used to add days to the week's start date for each day of the week (eg. week start date + 1 = Tueday)
        // https://stackoverflow.com/questions/563406/add-days-to-javascript-date
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
      },
      addWorkoutComments () {
        // Used to automatically add comments to a workout if they are generic
        if (this.dayType == 'Rest') {
          this.comments = 'Take the day completely off!'
        }
        else if (this.dayType == 'OMP Flat') {
          this.comments = '2nd half slightly faster than 1st half...average pace should be on target'
        }
        else if (this.dayType == 'OMP Plus') {
          this.comments = '1st 1/2: 15-20 sec/km slow, 1-2min rest, 2nd 1/2: 15-20 sec/km faster (or 25-30 sec/mi slower/faster)'
        }
        else if (this.dayType == 'OMP Hilly') {
          this.comments = '2nd half slightly faster than 1st half (APPRX. 1 HILL / 1mi or 2km)'
        }
        else if (this.dayType == 'X-Training') {
          this.comments = 'Easy intensity alternate activity...no running!'
        }
        else if (this.dayType == 'Intensity') {
          this.comments = 'Exactly 5% faster than   pace'
        }
        else if (this.dayType == 'Intensity (Tempo)') {
          this.comments = 'Remember to \'sandwich\' tempo work between the warmup & cooldown'
        }
        else if (this.dayType == 'Intensity (Cruise-Tempo)') {
          this.comments = 'Run @ tempo pace & take 1 min. rest every 10 min. (don\'t count rest in w/o)'
        }
        else if (this.dayType == 'Progression Start') {
          this.comments = 'Easy OMP set up for tomorrow\'s progression run finish'
        }
        else if (this.dayType == 'Progression Finish') {
          this.comments = '1st 3rd: >20s/K-30s/M Slow, 2nd 3rd: Near Trgt LSD pace, 3rd 3rd: >20s/K-30s/M FAST, LAST 3M/5K @ RP or faster'
        }
        // else if (this.dayType == 'Marapace/Race') {
        else if (this.dayType == 'Race Pace') {
          this.comments = ''
        }
        else if (this.dayType == 'LSD') {
          this.comments = 'Relax and enjoy it! Do 3-4 striders at the finish though'
        }
        else if (this.dayType == 'Fartlek') {
          this.comments = '1min. HARD (10K pace) & 2min EASY (L.S.D.), Repeat. Concentrate on form!'
        }
        else if (this.dayType == 'Race') {
          this.comments = 'Show time!'
        }
        else {
          this.comments = ''
        }
      },
    },
  }
</script>

<style>
  .week-header {
    font-family: Lato;
    margin-bottom: 8px;

    /* background-color: var(--coredarkcolor); */
    border-radius: 3px;

    height: 40px;
    line-height: 40px;
    padding: 0 14px 0 12px;
    position: relative;
    color: #fff;
    /* cursor: pointer; */
    font-weight: 700;
    font-size: 17px;
  }

  /* .training-day small {
    line-height: 1.15;
  }
  body small {
    line-height: 1.15;
  } */

  .day-info {
    display: block; /* https://stackoverflow.com/questions/6987834/how-to-make-an-inline-element-appear-on-new-line-or-block-element-not-occupy-th/6987857 */
    margin-bottom: 3px;
    font-weight: 700;
  }

  /* icons for health insurance and stuff */
  .other-stuff-check {
    display: -webkit-box;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    margin-top: 5px;
  }
  .incomplete-icon {
    font-size: 12px;
    margin-right: 3px;
  }
  .complete-icon {
    font-size: 12px;
    margin-right: 3px;
    color: green;
  }

  @media (min-width: 992px) {
    .training-day.col-lg-1 {
        -ms-flex: 0 0 14.285%;
        flex: 0 0 14.285%;
        max-width: 14.285%;
    }
  }

</style>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/myrundash/TrainingPlan.vue